import {makeRequest, makeRequestPut, makeRequestGet} from '../../Services/API';

export function getLeads(
    language,
    indexOfFirstItem,
    indexOfLastItem,
    nome,
    razaoSocial,
    nif,
    status,
    marca,
    representante,
    categoria,
    filtroNacionalInternacional,
    tipo,
    modelo,
    cidade,
    pais,

    signal,
) {
    return makeRequestGet(
        `/backend/leads/${language}/${indexOfFirstItem}/${indexOfLastItem}?nome=${nome ?? ''}&razaoSocial=${razaoSocial ?? ''}&nif=${nif ?? ''}${status ? `&status=${status}` : ''}&marca=${
            marca ?? ''
        }&representante=${representante ?? ''}&nacInternac=${filtroNacionalInternacional}&tipo=${tipo ?? ''}&modelo=${modelo ?? ''}&cidade=${cidade ?? ''}&pais=${pais ?? ''}&categoria=${
            categoria ?? ''
        }`,
        signal,
    );
}

export function gravarLead(lead, language) {
    return makeRequest(`/backend/gravarLead/${language}`, lead);
}

export function getLead(id, language) {
    return makeRequestGet(`/backend/lead/${id}/${language}`);
}

export function getLeadStatus(language) {
    return makeRequestGet(`/backend/getLeadStatus/${language}`);
}

export function getCortesias(language) {
    return makeRequestGet(`/backend/getCortesias/${language}`);
}
export function getFuncoes(language) {
    return makeRequestGet(`/backend/getFuncoes/${language}`);
}

export function getInteresses(language) {
    return makeRequestGet(`/backend/getInteresses/${language}`);
}
